import clsx from "clsx"

import { Card } from "@atoms"

import EmptyState from "@molecules/EmptyState/EmptyState"

import ObjectCardAttributes from "./Attributes/ObjectCardAttributes"
import ObjectCardBody from "./Body/ObjectCardBody"
import ObjectCardFooter from "./Footer/ObjectCardFooter"
import ObjectCardHeader from "./Header/ObjectCardHeader"
import { ObjectCardContext } from "./ObjectCard.context"
import styles from "./ObjectCard.module.scss"
import { ObjectCardProps } from "./ObjectCard.types"

function ObjectCardRoot(props: ObjectCardProps) {
    const { children, className, onClick, isDisabled = false, isLoading = false } = props
    // The error content, when the card is in its error state.
    const error = props.hasError ? props.error : null

    return (
        <ObjectCardContext.Provider value={{ isLoading }}>
            <Card
                // An errored card is never clickable; Card is only interactive when it has a click handler.
                onClick={error ? undefined : onClick}
                isDisabled={isDisabled}
                isLoading={isLoading}
                className={clsx(styles.base, className)}
            >
                <div className={styles.inner}>{error ? <EmptyState variant="error" {...error} /> : children}</div>
            </Card>
        </ObjectCardContext.Provider>
    )
}

const ObjectCard = Object.assign(ObjectCardRoot, {
    Header: ObjectCardHeader,
    Body: ObjectCardBody,
    Attributes: ObjectCardAttributes,
    Footer: ObjectCardFooter,
})

export default ObjectCard
